import React, { ReactElement } from 'react'

import { Currency } from '@ui/Currency'

interface MoneyProps {
  fractional: number
  currency: Currency
  signed?: boolean
  locale?: Locale
}

const Money = ({ fractional, currency, signed, locale }: MoneyProps): ReactElement => {
  return (
    <>
      {signed && fractional >= 0 && '+'}
      <Currency currency={currency} value={fractional} locale={locale} />
    </>
  )
}

export default Money
